<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="设备枪编号">
        <el-input placeholder="请输入设备枪编号" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="设备枪编号" prop="Enumber" width=""></el-table-column>
      <el-table-column label="二维码" prop="CodeUrl" width="">
        <template slot-scope="{ row }">
          <el-image v-if="row.CodeUrl" :src="row.CodeUrl" :preview-src-list="[row.CodeUrl]" class="station-img"
            fit="contain" :z-index="9999">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <span v-else style="color: #999;">暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column label="是否为私桩" prop="IsPrivate" width="">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.IsPrivate">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="State" width="">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.State == '在用'">启用</el-tag>
          <el-tag type="danger" v-else>禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="运行状态" prop="EIsStart" width=""></el-table-column>

      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!-- 新增or修改充电枪 -->
    <el-dialog :visible.sync="visible.editGroup" :title="isDetail ? '充电枪详情' : '新增充电枪'" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="设备枪编号" prop="Enumber" label-width="20%">
              <el-input placeholder="设备枪编号" v-model="form.Enumber" :disabled="isDetail" />
            </el-form-item>
            <el-form-item label="二维码" prop="CodeUrl" label-width="20%">
              <div v-if="isDetail">
                <div v-if="form.CodeUrl" class="image-preview-container">
                  <el-image :src="form.CodeUrl" :preview-src-list="[form.CodeUrl]"
                    style="width: 200px; height: 200px; object-fit: contain; border: 1px solid #e4e7ed; border-radius: 4px; cursor: pointer;"
                    fit="contain" :z-index="9999">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div v-else class="image-preview-container">
                  <span style="color: #999;">暂无图片</span>
                </div>
              </div>
              <div v-else>
                <file-upload listType="picture-card" :limit="1" @fileChange="fileChange" field="CodeUrl"
                  :fileList="form.CodeUrl"></file-upload>
              </div>
            </el-form-item>
            <el-form-item label="是否为私桩" prop="IsPrivate" label-width="20%">
              <el-input :value="form.IsPrivate ? '是' : '否'" :disabled="true" style="color: #606266;" />
            </el-form-item>
            <el-form-item label="状态" prop="State" label-width="20%">
              <el-input :value="form.State" :disabled="true" style="color: #606266;" />
            </el-form-item>
            <el-form-item label="运行状态" prop="EIsStart" label-width="20%">
              <el-input :value="form.EIsStart" :disabled="true" style="color: #606266;" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button v-if="!isDetail" @click="visible.editGroup = false">取消</el-button>
        <el-button v-if="!isDetail" type="primary" @click="onSubmit">确定</el-button>
        <el-button v-if="isDetail" type="primary" @click="visible.editGroup = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { getChargeGunPageList, modifyChargeGun, delChargeGun, addChargeGun, getPowerChargePileList } from "@/api/dev_archive"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      visible: {
        editGroup: false
      },
      tableData: [],
      form: {
        Enumber: "",
        CodeUrl: [],
        power_charge_pile_id: "",
        gun_num: "",
        remark: "",
      },
      chargePileOptions: [],
      formRules: {},
      filter: {
        groupName: ""
      },
      loading: false,
      isDetail: true,
      gid: ""
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.formRules = {}

    this.loadChargePileOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    // 加载充电桩选项
    loadChargePileOptions() {
      return getPowerChargePileList().then((res) => {
        if (res && res.data) {
          this.chargePileOptions = res.data.filter(item => !item.del)
          return this.chargePileOptions
        }
        return []
      }).catch((error) => {
        console.error('加载充电桩列表失败:', error)
        this.$message.error('加载充电桩列表失败')
        return []
      })
    },

    // 充电桩选择变化事件
    handleChargePileChange(value) {
      console.group('=== 充电桩选择变化 ===')
      console.log('选择的值 (充电桩ID):', value)

      if (value) {
        const selectedChargePile = this.chargePileOptions.find(item => item.ID === value)
        if (selectedChargePile) {
          console.log('充电桩名称:', selectedChargePile.name)
          console.log('充电桩地址:', selectedChargePile.address)
          console.log('充电桩资产码:', selectedChargePile.assets_code)
          console.log('充电桩完整信息:', selectedChargePile)
        } else {
          console.warn('未找到对应的充电桩信息')
          console.log('当前充电桩选项:', this.chargePileOptions)
        }
      } else {
        console.log('用户清空了选择')
      }
      console.groupEnd()
    },

    async onDetail(row) {
      this.visible.editGroup = true
      this.isDetail = true

      if (!this.chargePileOptions.length) {
        await this.loadChargePileOptions()
      }

      this.form = {
        Enumber: row.Enumber || "",
        CodeUrl: row.CodeUrl || "",
        power_charge_pile_id: row.power_charge_pile_id || "",
        gun_num: row.gun_num || "",
        remark: row.remark || "",
        IsPrivate: row.IsPrivate || false,
        State: row.State || "",
        EIsStart: row.EIsStart || "",
      }
      this.gid = row.ID

      console.log('详情行数据:', row)
      console.log('设置的表单数据:', this.form)
      console.log('设置的充电桩ID:', this.form.power_charge_pile_id)
    },

    fileChange(fileList, field) {
      if (!this.isDetail && field === 'CodeUrl') {
        if (fileList && fileList.length > 0) {
          this.form.CodeUrl = [fileList[0]]
        } else {
          this.form.CodeUrl = []
        }
      }
      console.log('图片上传变化:', field, fileList)
    },

    onDelete(row) {
      delChargeGun(row).then((res) => {
        this.$message.success(`删除成功`)
        this.toFilter()
      })
    },

    getData() {
      this.loading = true
      getChargeGunPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null

      })
        .then((res) => {
          const chargePileMap = {}
          this.chargePileOptions.forEach(chargePile => {
            chargePileMap[chargePile.ID] = chargePile.name || chargePile.address || chargePile.ID
          })

          this.tableData = res.data.map(item => {
            return {
              ...item,
              charge_pile_name: chargePileMap[item.power_charge_pile_id] || item.power_charge_pile_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },

    async onAdd() {
      this.visible.editGroup = true
      this.isDetail = false

      this.form = {
        Enumber: "",
        CodeUrl: [],
        power_charge_pile_id: "",
        gun_num: "",
        remark: "",
      }

      if (!this.chargePileOptions.length) {
        await this.loadChargePileOptions()
      }
    },

    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()

          let codeUrlString = ''
          if (this.form.CodeUrl && this.form.CodeUrl.length > 0) {
            codeUrlString = this.form.CodeUrl[0].url || ''
          }

          const reqData = {
            Enumber: this.form.Enumber,
            CodeUrl: codeUrlString,
            power_charge_pile_id: this.form.power_charge_pile_id,
            gun_num: this.form.gun_num,
            remark: this.form.remark,
          }

          console.log('提交的数据:', reqData)

          if (this.isDetail) {
            reqData.ID = this.gid
            modifyChargeGun(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addChargeGun(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.station-img {
  width: 80px;
  height: 80px;
  cursor: pointer;
  transition: transform 0.3s;
  object-fit: contain;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #f5f7fa;
}

.station-img:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 禁用状态下的输入框样式 */
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #606266;
  cursor: not-allowed;
}

/* 详情图片容器样式 */
.image-preview-container {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 10px;
  background-color: #f5f7fa;
  text-align: center;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 图片加载失败时的样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
</style>